import { render, staticRenderFns } from "./LeftGradientBlockLayoutHead.vue?vue&type=template&id=26f24a0f&"
import script from "./LeftGradientBlockLayoutHead.vue?vue&type=script&lang=js&"
export * from "./LeftGradientBlockLayoutHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports